let replaceURLWithHTMLLinks = (content, color) => {
	// 使用正则表达式匹配更广泛的URL格式(此正则由deepseek生成)
	const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
	return content.replace(urlRegex, (url) => {
	    // 如果URL不以http(s)://开头，则添加http://前缀
	    if (!url.startsWith("http")) {
	        url = "http://" + url;
	    }
	    return `<a href="${url}" target="_blank" style="color: ${color};text-decoration: underline;">${url}</a>`;
	});
}

// 将MinIO图片URL转换为Nginx代理路径
let fixImageUrl = (url) => {
	if (!url) return url;
	if (url.includes('http://') && url.includes('box-im/')) {
		// 处理 /file/box-im/ 路径
		if (url.includes('/file/box-im/')) {
			return url.replace(/http:\/\/[a-zA-Z0-9.:]+\/file\/(?=box-im\/)/, '/minio/');
		}
		// 处理 /box-im/ 路径
		return url.replace(/http:\/\/[a-zA-Z0-9.:]+\/(?=box-im\/)/, '/minio/');
	}
	return url;
}

export default {
	replaceURLWithHTMLLinks,
	fixImageUrl
}